import { useEffect } from 'react';

export const useHelloWorld = () => {
  useEffect(() => {});
};
